import React from "react";
import { Box, Chip, Stack, Typography } from "@mui/material";
import MissingProgressBar from "./MissingProgressBar";

const MissingProgressHeader = ({ title, description, progress }) => {
  const total = progress?.total || 0;
  const resolved = progress?.resolved || 0;
  const remaining = progress?.remaining || 0;
  const pct = total > 0 ? Math.round((resolved / total) * 100) : 0;

  return (
    <Box sx={{ mb: 2 }}>
      <Typography
        sx={{
          fontWeight: "bold",
          color: "#090909",
          fontSize: "0.9rem",
          textTransform: "capitalize",
          mb: 0.5,
        }}
      >
        {title}
      </Typography>
      <Typography
        sx={{
          fontWeight: 300,
          color: "#090909",
          fontSize: "0.8rem",
          mb: 1.5,
        }}
      >
        {description}
      </Typography>

      <Stack direction="row" spacing={1} sx={{ mb: 1 }}>
        <Chip size="small" label={`Total ${total}`} />
        <Chip size="small" color="success" label={`Resolved ${resolved}`} />
        <Chip size="small" color={remaining > 0 ? "warning" : "success"} label={`Remaining ${remaining}`} />
        <Chip size="small" variant="outlined" label={`${pct}% complete`} />
      </Stack>
      <MissingProgressBar value={pct} />
    </Box>
  );
};

export default MissingProgressHeader;
